import { api } from "./client";

export interface ScheduleSlot {
  id: number;
  day_of_week: number;
  start_minute: number;
  duration_min: number;
  label: string;
  is_paused: boolean;
  created_at: string;
}

export interface ScheduleSlotCreate {
  day_of_week: number;
  start_minute: number;
  duration_min?: number;
  label?: string;
}

export interface ScheduleSlotUpdate {
  day_of_week?: number;
  start_minute?: number;
  duration_min?: number;
  label?: string;
  is_paused?: boolean;
}

export const scheduleApi = {
  list: (deviceId: string) =>
    api.get<{ slots: ScheduleSlot[] }>(`/api/dashboard/devices/${deviceId}/schedule`),
  create: (deviceId: string, body: ScheduleSlotCreate) =>
    api.post<ScheduleSlot>(`/api/dashboard/devices/${deviceId}/schedule`, body),
  update: (deviceId: string, slotId: number, body: ScheduleSlotUpdate) =>
    api.patch<ScheduleSlot>(`/api/dashboard/devices/${deviceId}/schedule/${slotId}`, body),
  delete: (deviceId: string, slotId: number) =>
    api.delete<void>(`/api/dashboard/devices/${deviceId}/schedule/${slotId}`),
};
